import { render } from "./designAttachmentPrint.vue?vue&type=template&id=b542e8d6"
import script from "./designAttachmentPrint.vue?vue&type=script&lang=js"
export * from "./designAttachmentPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__